import { render, staticRenderFns } from "./DeliveriesTableHeader.vue?vue&type=template&id=f24d1394&"
import script from "./DeliveriesTableHeader.vue?vue&type=script&lang=ts&"
export * from "./DeliveriesTableHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports